import createDataReducer from "../../helpers/createDataReducer";
import deltas from "../../actions/deltas";
import {createSelector} from "reselect";

const {
    SET_ENROLMENTS,
    UPDATE_ENROLMENT,
    CLEAR_ENROLMENTS,
} = deltas.actionTypes;

export default createDataReducer(
    SET_ENROLMENTS,
    UPDATE_ENROLMENT,
    CLEAR_ENROLMENTS,
);

export const selectEnrolments = state => state.data.enrolments;
